<template>
    <div v-if="loadedOnce" class="notification is-info wlecome-info" style="font-size: 13px; margin-top: 20px;">
        <button @click="closeWelcomeInfo" class="delete" style="top: 15px; right: 15px;"></button>
        <span style="display:inline-block;margin-bottom:5px;"><strong>{{ welcomeMessage }}</strong></span>
        <br>This is your dashboard, the place where you can have a general overview about what is going on with your backups.
        <span v-if="newUser">In order to view useful information, you should connect your Cloud Provider Account (<b>DigitalOcean</b>, <b>AWS</b>, <b>Hetzner</b>, etc) <router-link :to="{ name: 'cloudlets'}">here</router-link> for cloud snapshots or your servers for <b>Database</b> & <b>File</b> backups <router-link :to="{ name: 'databases' }">here</router-link> and <router-link :to="{ name: 'files' }">here</router-link>.</span>
        <span v-if="existentUser">If you have questions or feedback, please do not hesitate to reach us out at <a href="mailto:hi@weap.io">hi@weap.io</a>. Your opinion is greatly appreciated.</span>
    </div>
</template>

<script>
import Api from '@/api';

export default {
    data() {
        return {
            loadedOnce: false,
            welcomeInfo: null,
        }
    },

    mounted() {
        this.getWelcomeInfo();
    },

    methods: {
        getWelcomeInfo() {
            Api().get('users/current/welcome-info')
                .then((response) => {
                    this.welcomeInfo = response.data;
                    this.loadedOnce = true;

                    if (!this.welcomeInfo.hide_welcome_info) {
                        Event.$emit('showWelcomeInfo');
                    }
                })
                .catch((error) => {
                    //
                });
        },

        closeWelcomeInfo() {
            Event.$emit('hideWelcomeInfo');
            Api().put('users/current/welcome-info');
        },
    },

    computed: {
        welcomeMessage() {
            if (this.welcomeInfo.active_accounts_count > 0) {
                if (this.welcomeInfo.first_name) {
                    return 'Welcome back, ' + this.welcomeInfo.first_name + '!';
                }
                return 'Welcome back!';
            }

            if (this.welcomeInfo.first_name) {
                return 'Welcome to Weap.io, ' + this.welcomeInfo.first_name + '!';
            }

            return 'Welcome to Weap.io!';
        },

        existentUser() {
            return this.welcomeInfo.active_accounts_count > 0;
        },

        newUser() {
            return this.welcomeInfo.active_accounts_count < 1;
        },
    },
}
</script>